export default "__VITE_ASSET__DMd8z6Pu__"